export default __webpack_public_path__ + "static/char-s-37-en-50ee05a97f7200e4d3ce1391883a4420.webp";